import React from 'react';
import { identifyComponent } from '../../../util';
import { TableBodyCellBase } from '../TableBodyCell/Base';
import { useBodyCells } from '../useBodyCells';
import { TableBodyRowBase } from './Base';
import { TableBodyRowProps } from './types';

export function TableBodyRow<R>({
  columns,
  row,
  className,
  cellComponent = TableBodyCellBase,
  cellProps = {},
  onClick,
  onMouseEnter,
  onMouseLeave,
  highlightOnHover,
  ...rest
}: TableBodyRowProps<R>) {
  const cells = useBodyCells(cellComponent, columns, row, cellProps);

  const handleClick = onClick
    ? () => {
        if (onClick) onClick(row);
      }
    : undefined;

  const handleMouseEnter = onMouseEnter
    ? () => {
        if (onMouseEnter) onMouseEnter(row);
      }
    : undefined;

  const handleMouseLeave = onMouseLeave
    ? () => {
        if (onMouseLeave) onMouseLeave(row);
      }
    : undefined;

  return (
    <TableBodyRowBase
      data-component="TableBodyRow"
      className={className}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      highlightOnHover={highlightOnHover}
      {...rest}
      {...identifyComponent('table-body-row')}
    >
      {cells}
    </TableBodyRowBase>
  );
}
